import { useQuery } from "@tanstack/react-query";

import { api, unwrap, type Schemas } from "@/shared/api/client";
import { makeKeys } from "@/shared/api/queryKeys";

export type MyWork = Schemas["MyWorkOut"];
export type WorkTask = Schemas["TaskOut"];
export type Mention = Schemas["MentionOut"];

export const myWorkKeys = makeKeys("my-work");

/** The signed-in person's open tasks by when they are due, plus reviews and mentions. */
export function useMyWork() {
  return useQuery({
    queryKey: myWorkKeys.all,
    queryFn: () => unwrap(api.GET("/api/v1/me/work")),
    staleTime: 0,
  });
}
